<template>
    <div class="memory-course">
        <div class="course-header">
            <div class="course-content">
                <div class="qtz-course"><img src="../../assets/imgs/course/memory-course-title-icon.png" alt="">专项能力课-记忆力</div>
                <ul class="course-detail">
                    <li>通过科学系统地记忆力专项训练，有效提升孩子记忆容量及记忆速度，</li>
                    <li>引导孩子形成记忆策略，为未来学习奠定坚实的基础。</li>
                </ul>
            </div>
        </div>

        <div class="course-content">
            <div class="course-content max-title" style="margin-bottom:0;border-bottom: none">
                <span>特色环节</span>
                <span>Characteristic games</span>
            </div>
            <div class="content-item">
                <div class="content-title">
                    <button class="page-btn">直观像</button>
                </div>
            </div>

            <ul class="list-text">
                <li>通过卡片和玩具的空间位置记忆游戏,提升孩子</li>
                <li>的工作记忆能力。</li>
            </ul>

            <ul class="list-text" style="display: flex;justify-content: space-between">
                <li>
                    <div style="margin-bottom: 14px"><img src="../../assets/imgs/course/memory-course-1.png" alt=""></div>
                    <div><img src="../../assets/imgs/course/memory-course-2.png" alt=""></div>
                </li>
                <li>
                    <img src="../../assets/imgs/course/memory-course-3.png" alt="">
                </li>
            </ul>

            <div class="content-item">
                <div class="content-title">
                    <button class="page-btn">连锁法</button>
                </div>
            </div>

            <ul class="list-text" style="display: flex;justify-content: space-between;align-items: center">
                <li>
                    <div style="flex:1">
                        <div>通过故事串联的形式,扩充孩子的记</div>
                        <div>忆容量,培养记忆策略,同时提升语</div>
                        <div>言表达能力。</div>
                    </div>
                </li>
                <li>
                    <img style="margin-right: 30px" src="../../assets/imgs/course/memory-course-4.png" alt="">
                    <img src="../../assets/imgs/course/memory-course-5.png" alt="">
                </li>
            </ul>

            <div class="content-item">
                <div class="content-title">
                    <button class="page-btn">PEG</button>
                </div>
            </div>

            <ul class="list-text" style="display: flex;justify-content: space-between;align-items: center">
                <li>
                    <div style="flex:1">
                        <div>将数字和图片做配对联想记忆,提升</div>
                        <div>数字敏感度和数字记忆力。</div>
                    </div>
                </li>
                <li>
                    <img style="margin-right: 30px" src="../../assets/imgs/course/memory-course-6.png" alt="">
                    <img src="../../assets/imgs/course/memory-course-7.png" alt="">
                </li>
            </ul>

            <div class="content-item">
                <div class="content-title">
                    <button class="page-btn">圆周率</button>
                </div>
            </div>

            <ul class="list-text">
                <li>以PEG记忆法为基础，记忆200位圆周率，提升记忆容量和专注力。</li>
            </ul>

            <div>
                <img src="../../assets/imgs/course/memory-course-8.png" alt="">
            </div>

            <div class="content-item" style="margin-top:40px;">
                <div class="content-title">
                    <button class="page-btn">扑克牌</button>
                </div>
            </div>

            <ul class="list-text">
                <li>借助扑克牌提升大年龄段孩子的图像记忆力,并在游戏中培养孩子的社交与协作能力。</li>
            </ul>

            <ul class="list-text">
                <li style="display: flex;">
                    <img style="margin-right:60px" src="../../assets/imgs/course/memory-course-9.png" alt="">
                    <img style="margin-right:60px" src="../../assets/imgs/course/memory-course-10.png" alt="">
                    <img style="margin-right:60px" src="../../assets/imgs/course/memory-course-11.png" alt="">
                    <img src="../../assets/imgs/course/memory-course-12.png" alt="">
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: "memory-course",
        data(){
            return {

            }
        }
    }
</script>

<style scoped lang="less">
    .memory-course{
        .course-header{
            background-image: url("../../assets/imgs/course/memory-course-bg.png");
        }
        .content-item{
            border-top: 1px solid #F8B300;
        }
        .page-btn{
            background: #F8B300;
        }
        .max-title{
            color: #F8B300;
            border-bottom: 1px solid #F8B300;
        }
        .list-text{
            margin: 30px 0;
            color: #6A6767;
            font-size: 16px;
            font-family: Light;
            li{
                img{
                    margin-right: 15px;
                }
            }
        }
    }
</style>